// extracted by mini-css-extract-plugin
module.exports =  {"root":"l1RloYQDdSu_aZWb8aow","toggle":"swoEFNvDfspQ7wgR2c1l","icon":"Xx91ROmn2cgcV4z1Ac3g","content":"UJDyAxYFFflIM0RmSJXM"};